import { ClassificationExpectation } from "./classification-expectation";
import { ClassificationWeight } from "./classification-weight";

export class ClassificationConfiguration {
    id: number;
    eventType: string;
    
    raiseWinThreshold: number;
    lowerWinThreshold: number;

    runThresholdOne: number;
    runThresholdTwo: number;
    runThresholdThree: number;

    expectations: ClassificationExpectation[];
    weights: ClassificationWeight[];
}


// WEBPACK FOOTER //
// ./src/model/classification-configuration.ts